import { render, staticRenderFns } from "./ButtonsTemplate.vue?vue&type=template&id=847bd1fc"
import script from "./ButtonsTemplate.vue?vue&type=script&lang=js"
export * from "./ButtonsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports